<template>
  <div style="height: 100%;background-color: #fbfbfb;">
    <div style="height: 50px;padding-top: 20px;margin: 0 20px">
      <el-button type="primary" plain icon="el-icon-plus" @click="addAwait">新建预约</el-button>
<!--      <el-input v-model="searchName" prefix-icon="el-icon-search" placeholder="输入姓名" style="width: 250px"></el-input>-->
<!--      <el-input v-model="searchCard" prefix-icon="el-icon-search" placeholder="输入身份证" style="width: 250px"></el-input>-->
<!--      <el-select v-fixZoom v-model="careLevel" filterable placeholder="请选择能力级别" style="width: 250px">-->
<!--        <el-option v-for="item in abilityLevelArr" :key="item.id" :label="item.name" :value="item.id">-->
<!--        </el-option>-->
<!--      </el-select>-->
<!--      <el-button type="success" @click="getSearchData">查询</el-button>-->
    </div>
    <div style="height: calc(100% - 120px);margin: 0 20px">
      <el-table :data="tableData" border highlight-current-row ref="singleTable" height="100%">
        <el-table-column
          type="index"
          label="序号"
          width="70"
          align="center">
        </el-table-column>
        <el-table-column
          prop="esp_time_create"
          label="预约时间"
          width="100"
          align="center">
        </el-table-column>
        <el-table-column
          prop="name"
          label="姓名"
          min-width="120"
          align="center">
        </el-table-column>
        <el-table-column
          prop="idcard_num"
          label="身份证"
          min-width="120"
          align="center">
        </el-table-column>
        <el-table-column
          prop="sex"
          label="性别"
          min-width="80"
          align="center">
          <template slot-scope="scope">
            <span>{{getSexDesc(scope.row.sex)}}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="birthday"
          label="生日"
          width="100"
          align="center">
          <template slot-scope="scope">
            <span>{{scope.row.birthday}}</span>
            <br>
            <span>{{getAgeDesc(scope.row.birthday)}}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="bed_name"
          label="预约床位"
          min-width="100"
          align="center">
          <template slot-scope="scope">
            <span>{{scope.row.bed_name === 0 ? '--' : scope.row.bed_name}}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="随时入住"
          min-width="80"
          align="center">
          <template slot-scope="scope">
            <span>{{getAtAnlyTimeDesc(scope.row.at_anly_time)}}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="计划入住时间"
          min-width="120"
          align="center">
          <template slot-scope="scope">
            <span>{{scope.row.at_anly_time === 1 ? '--' : scope.row.start_time}}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="计划退住时间"
          min-width="80"
          align="center">
          <template slot-scope="scope">
            <span>{{scope.row.at_anly_time === 1 ? '--' : scope.row.end_time}}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="deposit"
          label="押金"
          min-width="120"
          align="center">
        </el-table-column>
        <el-table-column align="center" label="操作" width="300">
          <template slot-scope="scope">
            <el-button size="mini" type="success" plain @click="openView(scope.row)">详情</el-button>
            <el-button size="mini" type="primary" plain @click="openEdit(scope.row)">修改</el-button>
            <el-button size="mini" type="danger" plain @click="delAwait(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div style="margin-top: 10px;height: 40px;text-align: center">
      <el-pagination v-fixZoom @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage"
                     :page-sizes="[10, 20, 50, 100]" :page-size="pageSize" :total="totalCells"
                     layout="total, sizes, prev, pager, next, jumper">
      </el-pagination>
    </div>
    <el-dialog :visible.sync="addEditShow" v-if="addEditShow" width="800px"
               :show-close="true" :close-on-click-modal="false" center class="all-open">
      <div class="title-top-alarm">
        <span>{{ titleShow }}</span>
        <div class="line-title"></div>
      </div>
      <add-edit-await v-model="addEditShow" :awaitObj="awaitObj" @updateTable="updateTable"></add-edit-await>
    </el-dialog>
  </div>
</template>

<script>
import addEditAwait from './components/addEditAwait'
import {accomodationgetbedwait, accomodationupdatebedwait} from '../../api/yanglaoyuan/homebed'
export default {
  name: 'awaitList',
  components: {addEditAwait},
  data () {
    return {
      entityId: 0,
      pageSize: 10,
      currentPage: 1,
      totalCells: 0,

      tableData: [],

      addEditShow: false,
      titleShow: '',
      awaitObj: {
        openType: 0,
        row: ''
      }
    }
  },
  created () {
    this.entityId = this.$store.state.user.LoginResp.entity_id
    // console.log(this.$store.state.user.LoginResp.entity_id)
    this.getSearchData()
  },
  methods: {
    handleSizeChange (val) {
      this.pageSize = val
      this.getSearchData()
    },
    handleCurrentChange (val) {
      this.currentPage = val
      this.getSearchData()
    },
    openView (row) {
      this.titleShow = '详情'
      this.awaitObj.row = row
      this.awaitObj.openType = 0
      this.addEditShow = true
    },
    addAwait () {
      this.titleShow = '新建预约'
      this.awaitObj.row = ''
      this.awaitObj.openType = 1
      this.addEditShow = true
    },
    openEdit (row) {
      this.titleShow = '修改预约'
      this.awaitObj.row = row
      this.awaitObj.openType = 2
      this.addEditShow = true
    },
    delAwait (row) {
      this.$confirm('此操作将取消该轮候登记, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'error'
      }).then(() => {
        let data = {
          oper_type: 2,
          pid: row.pid
        }
        accomodationupdatebedwait(data).then(res => {
          this.$notify({title: '成功', message: '成功取消该轮候登记', type: 'success', duration: 2000})
          this.updateTable()
        })
      })
    },
    getSearchData () {
      this.getBedWaitData()
    },
    updateTable () {
      this.getSearchData()
    },

    // table显示
    getSexDesc (sex) {
      return this.util.getSex(sex)
    },
    getAtAnlyTimeDesc (atAnlyTime) {
      let result = '未知'
      if (atAnlyTime === 1) {
        result = '是'
      } else if (atAnlyTime === 0) {
        result = '否'
      }
      return result
    },
    // 获取年龄描述 ****-**-**/age
    getAgeDesc (birthDate) {
      let result = ''
      let age = this.util.getAgeByBirth(birthDate)
      if (age === '') {
        result = '--'
      } else {
        result = age + '岁'
      }
      return result
    },

    // 访问接口
    getBedWaitData () {
      let params = {
        page: this.currentPage,
        size: this.pageSize
      }
      let data = {
        eid: this.entityId === 0 ? -1 : this.entityId
      }
      accomodationgetbedwait(params, data).then(res => {
        this.totalCells = res.data.cnt
        this.tableData = res.data.arrdata
      })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/oldPersonHome/awaitList.vue